import { Component, OnInit } from '@angular/core';

import { AuthService } from '../../../services/auth.service';
import { Router } from '@angular/router';
import * as moment from 'moment';
import { SnotifyService } from 'ng-snotify';
import { FillBatchReportService } from '../../../services/fill-batch-report.service';
import { ModalService } from '../../../services/modal.service';
import { MergeService } from '../../../services/merge.service';

@Component({
  selector: 'app-merge-management',
  templateUrl: './merge-management.component.html',
  styleUrls: ['./merge-management.component.css']
})
export class MergeManagementComponent implements OnInit {
  modalService: ModalService;
  snotifyService: SnotifyService;
  mergeService: MergeService;

  parameters: any = {
    merge_From_Id: null,
    merge_Into_Id: null
  };

  init: boolean;
  is_client = false;
  client;

  constructor(authService: AuthService, public fillBatchReportService: FillBatchReportService, public router: Router,
    modalService: ModalService, snotifyService: SnotifyService, mergeService: MergeService) {

    this.is_client = authService.currentUser.value.userType == 0;
    this.client = authService.currentUser.value;
    this.modalService = modalService;
    this.snotifyService = snotifyService;
    this.mergeService = mergeService;
  }

  ngOnInit() {
    this.init = true;
  }

  merge() {
    const mergeFromId = Number(this.parameters.merge_From_Id);
    const mergeIntoId = Number(this.parameters.merge_Into_Id);

    if (isNaN(mergeFromId) || isNaN(mergeIntoId)) {
      this.snotifyService.error("Invalid ID: Non-numeric data", { timeout: 3000 });
      return;
    }

    if (mergeFromId === 0 || mergeIntoId === 0) {
      this.snotifyService.error("Invalid ID: 0", { timeout: 3000 });
      return;
    }

    if (mergeFromId === mergeIntoId) {
      this.snotifyService.error("The from and into IDs cannot be the same.", { timeout: 3000 });
      return;
    }

    this.mergeService.merge(mergeFromId, mergeIntoId).then((merge) => {
      if (merge.success) {
        this.parameters.merge_From_Id = 0;
        this.parameters.merge_Into_Id = 0;
        this.snotifyService.success("Sucessfully Merged Cylinder", { timeout: 3000 });
      }
      else {
        this.snotifyService.error(`Failed to Merge Cylinder: ${merge.message}`, { timeout: 3000 });
      }
    });
  }





  gotoTop() {
    console.log("GOTO TOP");
    // window.scrollTo(-9999,-99999);
    let top = document.getElementById('top');
    console.log(top);
    if (top !== null) {
      top.scrollIntoView(true);
      //  document.getElementById("top").scrollTop -= 99999;
      top = null;
    }
  }
}

